import { useContext } from 'react'

// context
import { AppContext } from '../../../App'

// icons
import { ReactComponent as InfoIcon } from '../../../assets/icons/info.svg'

// components
import ActionCards from '../../action-cards/action-cards'
import { ActionCardProps } from '../../action-cards/components/action-card/action-card'
import StepCard from '../../step-card/step-card'

// styles
import styles from './nba-page.module.scss'

const NBAPage = (): JSX.Element => {
	const appContext = useContext(AppContext)

	const nextBestActions = appContext?.biomechanicalReport?.nextActions || []

	return (
		<StepCard stepTitle="Next Best Action">
			<div className="animate-appear">
				<ActionCards
					cards={nextBestActions.map(
						(action, index): ActionCardProps => {
							return {
								name: `recommendation-${index}`,
								title: action.title,
								description:
									action.body?.replace(
										/AssessHealthTM/gi,
										'AssessHealth<sup>TM</sup>'
									) || '',
								recommended: action.recommended,
							}
						}
					)}
				/>
				<p className={styles.info}>
					<InfoIcon />
					The text will be automaticly added to claims notes with a
					indicator of the agreement after you confirm your choice.
				</p>
			</div>
		</StepCard>
	)
}
export default NBAPage
